import controller from './cart.controller';
import templateT1 from './templates/cart-t1.view.html';
import templateAD from './templates/cart-base.view-adaptative.html';

let CartComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if(__env.adaptative){
        return templateAD;
    } else {  
        return templateT1;
    }
}

export default CartComponent;



/** WEBPACK FOOTER **
 ** ./www/components/cart/cart.component.js
 **/